import { useEffect } from 'react';

const SITE_NAME = 'BuyWize';
const DEFAULT_TITLE = 'BuyWize - Expert Product Reviews, Comparisons & Buying Guides';
const DEFAULT_DESCRIPTION = 'BuyWize helps you find the best products before you buy. Expert reviews, side-by-side product comparisons, and buying guides across electronics, gaming, home, kitchen and more.';

function upsertMetaDescription(content: string) {
  let tag = document.querySelector('meta[name="description"]');
  if (!tag) {
    tag = document.createElement('meta');
    tag.setAttribute('name', 'description');
    document.head.appendChild(tag);
  }
  tag.setAttribute('content', content);
}

/** Sets document.title + meta description for the current page. Google executes JS and will
 *  pick these up; Facebook/Pinterest link-preview crawlers do not run JS, so this alone won't
 *  produce per-page social link previews. That's handled separately for the social pipeline. */
export function usePageMeta(title?: string, description?: string) {
  useEffect(() => {
    document.title = title ? `${title} | ${SITE_NAME}` : DEFAULT_TITLE;
    upsertMetaDescription(description?.trim() || DEFAULT_DESCRIPTION);
    return () => {
      document.title = DEFAULT_TITLE;
      upsertMetaDescription(DEFAULT_DESCRIPTION);
    };
  }, [title, description]);
}
